import script from "./UploadStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadStatus.vue?vue&type=script&lang=ts&setup=true"

import "./UploadStatus.vue?vue&type=style&index=0&id=bd831032&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd831032"]])

export default __exports__